export default __webpack_public_path__ + "static/media/pkt2.08542bbe.svg";